import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import $ from 'init/jquery'

@Defaults({
  openClass: 'open',
  innerBlockClass: 'block-inner',
  events: {
    'click li.menu-select': 'toggleBlock',
  },
})
export class ExpandableBlockView extends View {
  /**
   * Открытие и закрытие пунктов нижнего меню
   * @param {Event} event
   */
  toggleBlock (event) {
    const block = $(event.currentTarget),
      target = $(event.target)

    if (!target.closest(`.${this.innerBlockClass}`).length) {
      block.toggleClass(this.openClass)
      event.preventDefault()
    }
  }

  /**
   * Открыть блок
   * @param {jQuery} block
   */
  openBlock (block) {
    block.addClass(this.openClass)
  }
}
